export const MIN_PRICE = 15;
export const MAX_PRICE = 10000;
